import { GENERAL_GRAPH, GRAPH_GRAPH_RESULTS, } from "./types";
export const generalGraphActions = (payload) => ({ type: GENERAL_GRAPH, payload });
export const generalGraphResultsActions = (payload) => ({
    type: GRAPH_GRAPH_RESULTS,
    payload,
});
